// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17qRT","questions":"styles_questions__2H3o0","footer":"styles_footer__5ZYHW"};